import { Component, ViewEncapsulation, OnInit, Input, SimpleChanges, AfterViewInit, OnDestroy, OnChanges, ElementRef, ViewChild,
         Output, EventEmitter } from '@angular/core';
import { PageComboBoxModel } from './page-combo-box.model';
import { PlessViewHelper } from '../../../../shared/pless-view-helper';
import { GetPageListService } from './api-services/get-page-list.service';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';

/**
 * ページリストを管理するクラス
 *
 * @export PageComboBoxComponent
 * @class PageComboBoxComponent
 */
@Component({
  selector: 'app-page-combo-box',
  templateUrl: 'page-combo-box.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: PageComboBoxComponent,
      multi: true
    },
    {
      provide: GetPageListService,
      useFactory: (plessHttp: PlessHttp, dialogService: PlessDialogServiceSub) => {
        return new GetPageListService(plessHttp, dialogService);
      },
      deps: [PlessHttp, PlessDialogServiceSub]
    }
  ],
  encapsulation: ViewEncapsulation.None
})
export class PageComboBoxComponent extends PlessViewHelper implements OnInit, AfterViewInit, OnChanges, OnDestroy, ControlValueAccessor {

  public selectedIndex: number = <number>-1;
  public selectedPageId: string = <string>'';                                   // ページＩＤ
  public selectedPageNum: string = <string>'';                                  // ページ番号
  public selectedPageInfo: string = <string>'';                                 // ページ情報
  public selectedOrderCode: string = <string>'';                                // 受注コード
  public selectedMediumType: string = <string>'';                               // 媒体区分
  public selectedCoopCode: string = <string>'';                                 // 生協コード
  public selectedPagetemplateId: string = <string>'';                           // ページテンプレートID
  public selectedPositionX: string = <string>'';                                // 始点Ｘ
  public selectedPositionY: string = <string>'';                                // 始点Ｙ
  public selectedSizeW: string = <string>'';                                    // 幅
  public selectedSizeH: string = <string>'';                                    // 高さ
  public selectedDivX: string = <string>'';                                     // X分割数
  public selectedDivY: string = <string>'';                                     // Y分割数

  /** マネージャー */
  public model: PageComboBoxModel = new PageComboBoxModel();

  @ViewChild('comboBox', { static: true }) public comboBox: ElementRef;

  @Input() public subid: string = null;
  @Input() initAutoLoad: boolean = <boolean>true;                               // オートロードフラグ
  @Input() orderCode: string = <string>'';                                      // 検索条件「受注コード」を設定する(voの値)
  @Input() mediumType: string = <string>'';                                     // 検索条件「媒体区分」を設定する
  @Input() coopCode: string = <string>'';                                       // 検索条件「生協コード」を設定する
  @Input() tabindex: number = null;
  @Input() labelField: string = <string>'PageInfo';
  @Input() blank: boolean = <boolean>true;                                      // 先頭空白表示追加フラグ
  @Input() allPage: boolean = <boolean>false;                                   // 先頭【全ページ】追加フラグ
  @Input() notCarrying: boolean = <boolean>false;                               // 先頭【非掲載】追加フラグ
  @Input() forcedEnabledMode: string = null;

  // レイアウト系の変数
  @Input() left: number = <number>0;
  @Input() top: number = <number>0;
  @Input() width: number | string;
  @Input() height: number = <number>20;
  @Input() disabled: boolean = <boolean>false;
  @Input() required: boolean = <boolean>false;
  @Input() initFocusItem: any = null;                                           // ロード完了後フォーカスを移動させるid
  @Input() afterFocus: any = null;                                              // ロード完了後フォーカスを移動させるid
  @Input() visible: boolean = <boolean>true;                                    // 表示・非表示フラグ

  @Output() nextFunc: EventEmitter<any> = new EventEmitter;

  /**
   * Creates an instance of PageComboBoxComponent.
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetPageListService} getPageListService
   * @memberof PageComboBoxComponent
   */
  constructor(
    public elementRef: ElementRef,
    private dialogService: PlessDialogServiceSub,
    public getPageListService: GetPageListService,
  ) {
    super();
  }

  // ValueAccessor
  public onChange(_: any) { }
  public onTouched() { }
  public writeValue(text: string): void {
    if (text !== this.selectedPageId) {
      this.selectedPageId = text;
      this.setPageId(text);
    }
  }
  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    /** コンボボックスインスタンス設定 */
    this.model.component = this;
    this.comboBox.nativeElement.setAttribute('id', this.subid + '_sub');
    this.comboBox.nativeElement.setAttribute('forcedEnabledMode', this.forcedEnabledMode);
  }

  /**
   * ロード完了時
   *
   * @memberof pageComboBox
   */
  ngAfterViewInit(): void {
    this.reload();
  }

  /**
   * 値変更時イベント
   *
   * @param {SimpleChanges} changes 変更イベント
   * @memberof codeComboBox
   */
  ngOnChanges(changes: SimpleChanges): void {
    Object.keys(changes).forEach((propName) => {
      switch (propName) {
        case 'blank':
          /** 先頭空白表示フラグ */
          this.model.blank = changes.blank.currentValue;
          break;
        case 'allPage':
          /** 先頭【全ページ】追加フラグ */
          this.model.allPage = changes.allPage.currentValue;
          break;
        case 'notCarrying':
          /** 先頭【非掲載】追加フラグ */
          this.model.notCarrying = changes.notCarrying.currentValue;
          break;
        case 'initAutoLoad':
          /** 初期データ自動取得フラグ */
          this.model.initAutoLoad = changes.initAutoLoad.currentValue;
          break;
        case 'orderCode':
          /** 検索条件「受注コード」を設定するフラグ */
          this.orderCode = changes.orderCode.currentValue;
          this.reload();
          break;
        case 'mediumType':
          /** 検索条件「媒体区分」を設定するフラグ */
          this.mediumType = changes.mediumType.currentValue;
          this.reload();
          break;
        case 'coopCode':
          /** 検索条件「生協コード」を設定するフラグ */
          this.coopCode = changes.coopCode.currentValue;
          this.reload();
          break;
      }
    });
  }

  /**
   * コンポーネント終了時
   *
   * @memberof mediumTypeComboBox
   */
  ngOnDestroy(): void {
    /** コンボボックス情報初期化 */
    this.clear();
  }

  public clear(): void {
    /** コンボボックス情報初期化 */
    this.selectedPageId = null;
    this.selectedPageNum = null;
    this.selectedPageInfo = null;
    this.selectedOrderCode = null;
    this.selectedMediumType = null;
    this.selectedCoopCode = null;
    this.selectedPagetemplateId = null;
    this.selectedPositionX = null;
    this.selectedPositionY = null;
    this.selectedSizeW = null;
    this.selectedSizeH = null;
    this.selectedDivX = null;
    this.selectedDivY = null;
    this.orderCode = null;
    this.mediumType = null;
    this.coopCode = null;
    this.model = new PageComboBoxModel();
    this.model.component = this;
    this.model.blank = this.blank;
    this.model.allPage = this.allPage;
    this.model.notCarrying = this.notCarrying;
  }

  /**
   * コンボボックスの選択Nameを切り替える
   *
   * @param {string} pageId ページID
   * @memberof PageComboBoxComponent
   */
  setPageId(pageId: string): void {
    this.model.setPageId = pageId;

    /** ロード完了の場合 */
    if (this.model.completeUpdateFlg) {
      this.updateSelectedPage();
    }
  }

  /**
   * コンボボックスの選択コードNameを切り替える(ページ番号で切替)
   *
   * @param {string} pageNum ページ番号
   * @memberof PageComboBoxComponent
   */
  setPageNum(pageNum: string): void {
    this.model.setPageNum = pageNum;
  }

  /**
   * ページ再表示用インターフェースを設定する
   *
   * @param {IPageView} iPageView
   * @memberof PageComboBoxComponent
   */
  setIPageView(iPageView: IPageView): void {
    this.model.iPageView = iPageView;
  }

  /**
   * コンボボックスの選択コードNameを切り替える
   *
   * @memberof PageComboBoxComponent
   */
  updateSelectedPage(): void {
    const pageList: Array<any> = this.model.pageList;

    for (let i = Number(0); i < pageList.length; i++) {
      if (pageList[i] != null && pageList[i].PageId === this.model.setPageId) {
        this.selectedIndex = i;
      }

      // バインドフィールドを更新
      this.updateBindedField(null);
    }
  }

  /**
   * コンボボックスの選択コードNameを切り替える(ページ番号で切替)
   *
   * @memberof PageComboBoxComponent
   */
  updateSelectedPage_byPageNum(): void {
    const pageList: Array<any> = this.model.pageList;

    // ページ一覧のチェック
    for (let i = Number(0); i < pageList.length; i++) {
      if (pageList[i] != null && PlessViewUtilsSub.trim(pageList[i].PageNum) === this.model.setPageNum) {
        // 初期設定ページ番号に該当するページが存在する場合、選択ページに設定
        this.selectedIndex = i;
        this.updateBindedField(null);
      }
      // 上記以外の場合、選択ページを設定しない
    }

    // 初期設定ページ番号をクリア
    this.setPageNum('');
  }

  /**
   * バインドフィールド初期化
   *
   * @private
   * @param {*} e
   * @returns {void}
   * @memberof PageComboBoxComponent
   */
  public updateBindedField(e: any): void {
    if (e != null) {
      this.selectedIndex = e.target.selectedIndex;
    }
    if (this.selectedIndex === -1) {
      this.selectedPageId = null;
      this.selectedPageNum = null;
      this.selectedPageInfo = null;
      this.selectedOrderCode = null;
      this.selectedMediumType = null;
      this.selectedCoopCode = null;
      this.selectedPagetemplateId = null;
      this.selectedPositionX = null;
      this.selectedPositionY = null;
      this.selectedSizeW = null;
      this.selectedSizeH = null;
      this.selectedDivX = null;
      this.selectedDivY = null;
      return;
    }

    this.selectedPageId = this.model.pageList[this.selectedIndex].PageId;
    this.selectedPageNum = this.model.pageList[this.selectedIndex].PageNum;
    this.selectedPageInfo = this.model.pageList[this.selectedIndex].PageInfo;
    this.selectedOrderCode = this.model.pageList[this.selectedIndex].OrderCode;
    this.selectedMediumType = this.model.pageList[this.selectedIndex].MediumType;
    this.selectedCoopCode = this.model.pageList[this.selectedIndex].CoopCode;
    this.selectedPagetemplateId = this.model.pageList[this.selectedIndex].PageTemplateId;
    this.selectedPositionX = this.model.pageList[this.selectedIndex].PositionX;
    this.selectedPositionY = this.model.pageList[this.selectedIndex].PositionY;
    this.selectedSizeW = this.model.pageList[this.selectedIndex].SizeW;
    this.selectedSizeH = this.model.pageList[this.selectedIndex].SizeH;
    this.selectedDivX = this.model.pageList[this.selectedIndex].DivX;
    this.selectedDivY = this.model.pageList[this.selectedIndex].DivY;
  }

  /**
   * ページ情報一覧を再表示する
   *
   * @returns {void}
   * @memberof PageComboBoxComponent
   */
  public reload(): void {

    // 検索条件チェック
    if (PlessViewUtilsSub.isEmpty(this.orderCode) ||
      PlessViewUtilsSub.isEmpty(this.mediumType) ||
      PlessViewUtilsSub.isEmpty(this.coopCode)) {
      this.selectedIndex = 0;
      this.selectedPageId = '';
      this.selectedPageNum = '';
      this.selectedPageInfo = '';
      this.selectedOrderCode = '';
      this.selectedMediumType = '';
      this.selectedCoopCode = '';
      this.selectedPagetemplateId = '';
      this.selectedPositionX = '';
      this.selectedPositionY = '';
      this.selectedSizeW = '';
      this.selectedSizeH = '';
      this.selectedDivX = '';
      this.selectedDivY = '';

      if (PlessViewUtilsSub.isEmpty(this.orderCode)) {
        this.mediumType = '';
      }

      this.model.pageList = new Array<any>();

      return;
    }
    // 検索を行う

    // データ取得
    this.getPageListService.execute(this.model, this.orderCode, this.mediumType, this.coopCode, () => {
      this.nextFunc.emit();
    });
  }

}
